import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Accordion from '@components/Accordion';
import AccordionItem from '@components/Accordion/components/AccordionItem';
import { APP_TEXTS } from '@texts';
import WoodConnectionBracket from '../components/WoodConnectionBracket/WoodConnectionBracket';
import HolesConfiguration from '../components/HolesConfiguration/HolesConfiguration';
import HolesConfigurationB from '../components/HolesConfigurationB/HolesConfigurationB';

const WoodConnection = ({ appStatus }) => (
  <div>
    <Accordion className="application__accordion" appStatus={appStatus}>
      <AccordionItem 
        id="wood-anchor" 
        title={APP_TEXTS.WOOD_CONNECTION_TAB_BRACKET.Content}
      >
        <WoodConnectionBracket />
      </AccordionItem>
      <AccordionItem 
        id="wood-anchor1" 
        title={APP_TEXTS.WOOD_CONNECTION_TAB_HOLES_CONFIG.Content}
      >
        <HolesConfiguration />
      </AccordionItem>
      <AccordionItem 
        id="wood-anchor2" 
        title={APP_TEXTS.WOOD_CONNECTION_TAB_HOLES_CONFIG_B.Content}
      >
        <HolesConfigurationB />
      </AccordionItem>
    </Accordion>
  </div>
);

WoodConnection.propTypes = {
  appStatus: PropTypes.string
};

const mapState = state => ({
  appStatus: state.main.status
});

export default connect(mapState)(WoodConnection);



// WEBPACK FOOTER //
// ./src/views/Dimension/WoodConnection/WoodConnection.js